import { render } from "./PdfDBParser.vue?vue&type=template&id=f65705c6&scoped=true"
import script from "./PdfDBParser.vue?vue&type=script&lang=js"
export * from "./PdfDBParser.vue?vue&type=script&lang=js"

import "./PdfDBParser.vue?vue&type=style&index=0&id=f65705c6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f65705c6"]])

export default __exports__